import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    List,
    ListAdornment,
    ListBody,
    ListItem,
    MarkdownContent,
    Section,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { buildSearchUrlPath } from 'wanderu-utils';

import cgConfig from '../../../config/carrierguide.locale';

import styles from './TableList.scss';

function RoutesTable(props) {
    const {
        c2cRoute,
        i18nMoment,
        i18nMoney,
        locale,
        t,
    } = props;
    const {
        arrive_city: arriveCity,
        arrive_place_id: arriveId,
        c2c_id: id,
        depart_city: departCity,
        depart_date: travelDate,
        depart_place_id: departId,
        min_price_usd: minPrice,
    } = c2cRoute;

    let departDate;
    if (travelDate) {
        departDate = i18nMoment.parseZone(travelDate).shortDayAndWeekday(locale);
    }

    const searchUrlRequest = {
        arrivePlace: arriveCity,
        arrivePlaceId: arriveId,
        departDate: travelDate,
        departPlace: departCity,
        departPlaceId: departId,
    };

    const searchUrl = buildSearchUrlPath(searchUrlRequest);

    return (
        <ListItem
            className={styles.routeNew}
            key={id}
        >
            <A
                className={styles.routeLink}
                href={searchUrl}
                rel="nofollow"
                underline="none"
                variant="subdued"
            >
                <ListBody>
                    <Typography className={styles.routeTitle}>
                        {t('topRouteRouteString', {
                            arriveCityName: arriveCity,
                            departCityName: departCity,
                        })}
                    </Typography>
                    <Typography>
                        {departDate}
                    </Typography>
                </ListBody>
                <ListAdornment>
                    <Typography className={styles.price}>
                        {i18nMoney(minPrice).format({
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0,
                        })}
                    </Typography>
                </ListAdornment>
            </A>
        </ListItem>
    );
}

RoutesTable.propTypes = {
    c2cRoute: PropTypes.object.isRequired,
    i18nMoment: PropTypes.func.isRequired,
    i18nMoney: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
};

const LocalizedRoutesTable = localize(RoutesTable, cgConfig.namespace);

function TableList(props) {
    const {
        c2cRoutes = [],
        cheapest = false,
        i18nMoney,
        locale,
        minPrice,
        t,
    } = props;

    if (!c2cRoutes.length) {
        return null;
    }

    const title = cheapest
        ? t('cheapTripTitle')
        : t('topRouteTitle');
    const description = cheapest
        ? t('cheapTripDescription', { minTicketPriceUSD: i18nMoney(minPrice).format() })
        : t('topRouteDescription');
    const idString = cheapest
        ? 'cheapest'
        : 'popular';

    return (
        <Section
            className={styles.tableListSection}
            classes={{ content: styles.tableListContentNew }}
            id={`cg-${idString}-routes-title-section`}
        >
            <div>
                <Typography
                    className={styles.title}
                    component="h2"
                    variant="h3"
                >
                    {title}
                </Typography>
                <Typography
                    component={MarkdownContent}
                    paragraph
                >
                    {description}
                </Typography>
            </div>
            <List>
                {c2cRoutes.map((c2cRoute) => (
                    <LocalizedRoutesTable
                        c2cRoute={c2cRoute}
                        key={c2cRoute.c2c_id}
                        locale={locale}
                    />
                ))}
            </List>
        </Section>
    );
}

TableList.propTypes = {
    c2cRoutes: PropTypes.arrayOf(PropTypes.object),
    cheapest: PropTypes.bool,
    i18nMoney: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    minPrice: PropTypes.number,
    t: PropTypes.func.isRequired,
};

export { TableList };
export default localize(TableList, cgConfig.namespace);
